module.exports = __webpack_public_path__ + "static/contact-9b82a7c08684a32250b13ced25495644.svg";